import { sgVersion } from "../common/helpers";

declare global {
  interface Window {
    authInited: boolean,
    squircleInited: boolean,
    activationCode?: string,
    userId?: string,
    authPage?: string
  }

  namespace CSS {
    // noinspection ES6ConvertVarToLetConst
    var paintWorklet: {
      addModule: (url: string) => Promise<void>
    }
  }
}

export const authInit = async () => {
  if (window.authInited) {
    return
  }
  window.authInited = true
  const hasUrl = !window.isLoggedIn && window.location.hash.startsWith('#auth/')
  if (hasUrl) {
    const hash = window.location.hash
    if (hash.startsWith('#auth/')) {
      const route = hash.split('/')
      const page = route[1]
      window.authPage = page
      if (page === 'activate') {
        window.activationCode = route[2]
      }
      if (page === 'new-password') {
        window.userId = route[2]
        window.activationCode = route[3]
      }
    }
    const AuthDialog = (await import(`/dist/js/components/Auth/AuthDialog.js?${sgVersion()}`)).default
    await AuthDialog.show()
  }
}

export default async function (elements: NodeListOf<HTMLElement>) {
  // noinspection UnnecessaryLocalVariableJS
  const attachHandler = (await import(`/dist/js/components/Auth/AuthPlugin.js?${sgVersion()}`)).attachHandler
  elements.forEach(attachHandler)
}
